import { useEffect, useState } from "react";
import { API, api } from "@/lib/api";

export const goUrl = (store: "amazon" | "craft", q: string, src: string) =>
  `${API}/go?store=${store}&q=${encodeURIComponent(q)}&src=${encodeURIComponent(src)}`;
export const pickUrl = (id: string, src: string) => `${API}/go/pick/${id}?src=${encodeURIComponent(src)}`;
export const AFF_REL = "sponsored nofollow noopener";

let craftName: string | null = null;

export function useCraftName() {
  const [name, setName] = useState<string>(craftName || "Michaels");
  useEffect(() => {
    if (!craftName) api.get("/public/affiliate").then((r) => { craftName = r.data.craft_name; setName(r.data.craft_name); }).catch(() => {});
  }, []);
  return name;
}

export function AffiliateDisclosure({ className = "" }: { className?: string }) {
  return (
    <p className={`rounded-xl bg-[#F3EEE3] px-4 py-3 text-xs leading-relaxed text-[#23324A]/75 ${className}`} data-testid="affiliate-disclosure">
      Some links on this page are affiliate links. If you buy through them, I may earn a small commission at no extra cost to you.
      As an Amazon Associate I earn from qualifying purchases.
    </p>
  );
}
